export const HOME_PAGE_PATH = "/home";

export const TERMS_AND_CONDITIONS_PATH =
  "https://www.tdcx.com/policies/terms-of-use";

export const PRIVACY_POLICY_PATH = "https://www.tdcx.com/policies/privacy";
export const PRELIMINARY_TEST_PATH = "/start/preliminary-test";
